import React, { useState } from 'react';
import { Edit3 } from 'lucide-react';
import type { Place } from '../../types';
import { SuggestChangesModal } from './SuggestChangesModal';

interface SuggestChangesButtonProps {
  place: Place;
  userId?: string;
  userName?: string;
  userEmail?: string;
  onShowNotification?: (message: string, type: 'success' | 'error' | 'info') => void;
  onAuthRequired?: () => void;
}

export function SuggestChangesButton({
  place,
  userId,
  userName,
  userEmail,
  onShowNotification,
  onAuthRequired,
}: SuggestChangesButtonProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleClick = () => {
    if (!userId) {
      onAuthRequired?.();
      return;
    }
    setIsModalOpen(true);
  };

  return (
    <>
      <button
        onClick={handleClick}
        className="w-full py-3 border border-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-50 transition flex items-center justify-center gap-2"
      >
        <Edit3 className="w-5 h-5" />
        Änderung vorschlagen
      </button>

      {userId && userName && (
        <SuggestChangesModal
          isOpen={isModalOpen}
          place={place}
          userId={userId}
          userName={userName}
          userEmail={userEmail}
          onClose={() => setIsModalOpen(false)}
          onShowNotification={onShowNotification}
        />
      )}
    </>
  );
}

export default SuggestChangesButton;
